import { PUBLIC_OFFER_TABLE_COLUMNS } from '../components/table'

export const publicOfferDataPreparation = ({ data, combos, intl }) => {
  if (!Array.isArray(data)) {
    return []
  }

  return data.map((item) => {
    if (!item || typeof item !== 'object') {
      return {
        id: null,
        activa: false,
        is_removable: false,
      }
    }

    const formattedDates = {}
    const formattedText = {}
    PUBLIC_OFFER_TABLE_COLUMNS.forEach((column) => {
      if (column.type === 'date' && item[column.field]) {
        formattedDates[column.field] = intl.formatDate(item[column.field])
      }
      if (column.multiple && Array.isArray(item[column.field]) && item[column.field].length > 0) {
        const itemValues = item[column.field].map(({ nombre }) => nombre)
        formattedText[column.field] = itemValues.join(', ')
      }
    })

    return {
      ...item,
      ...formattedDates,
      ...formattedText,
      activa: item.activa ?? false,
      is_removable: item.is_removable ?? false,
      id: item.id ?? null,
      tableData: {
        ...item.tableData,
      },
    }
  })
}
